import { Col, Row, Select, Spin, Tag, Tooltip } from 'antd'
import CandidatePfd from './candidate-pfd'
import CandidateForm from './candidate-form'
import { BackIcon } from '../../../assets/icons'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { PRIVATE_ROUTES } from '../../../routes'
import { CANDIDATE_STATUS } from './candidate-status-tab-list'
import StatusModal from './status-modal'
import { useState } from 'react'

const CandidateDetails = ({ pdfUrl, selectedStatus }) => {
    const [statusModal, setStatusModal] = useState({
        open: false,
        candidate: null,
        status: null,
    })
    const { isLoading, cnadidateResusmeUrl, candidateDetails, activeTab } =
        useSelector((state) => state.candidateSlice)
    const currentStatus = CANDIDATE_STATUS.find(
        (status) => status.value === candidateDetails?.status
    )

    const navigate = useNavigate()
    return (
        <div>
            <Spin spinning={isLoading ? true : false}>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                        }}
                    >
                        <Tooltip title={"Change Status"}>
                            <Tag
                                color={currentStatus?.color}
                                style={{ marginRight: 8, cursor: candidateDetails?.status === "convertToUser" ? "auto" : 'pointer' }}
                                onClick={() => {
                                    if (candidateDetails?.status === "convertToUser") return

                                    setStatusModal({
                                        open: true,
                                        candidate: candidateDetails,
                                        status: candidateDetails?.status,
                                    })
                                }}
                            >
                                {currentStatus?.label}
                            </Tag>
                        </Tooltip>
                        <Tooltip title={'Back'}>
                            <div
                                style={{
                                    height: '30px',
                                    width: '30px',
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    navigate(PRIVATE_ROUTES.candidate.root)
                                }
                            >
                                <BackIcon />
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <Row gutter={[25, 20]}>
                    <Col xs={24} sm={12} md={13} lg={13} xl={13}>
                        <div>
                            <CandidatePfd pdfUrl={cnadidateResusmeUrl} />
                        </div>
                    </Col>
                    <Col xs={24} sm={12} md={11} lg={11} xl={11}>
                        <CandidateForm />
                    </Col>
                </Row>
            </Spin>
            <StatusModal
                activeStatus={activeTab}
                statusModal={statusModal}
                setStatusModal={setStatusModal}
                open={statusModal.open}
                isDetailsApi={true}
                selectedStatus={statusModal?.status}
                isDetails={statusModal?.candidate?.isCompleteCandidateDetails}
                onClose={() => setStatusModal({ open: false, candidate: null })}
                onChange={(newStatus) =>
                    setStatusModal((prev) => ({
                        ...prev,
                        status: newStatus,
                    }))
                }
            />
        </div>
    )
}

export default CandidateDetails
